"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetStrategy = exports.defaultUrl = void 0;
const createIframe = (widget) => {
    const connector = document.createElement("iframe");
    connector.src = widget;
    connector.style.border = "none";
    connector.style.zIndex = "10000";
    connector.style.position = "fixed";
    connector.style.display = "none";
    connector.style.top = "0";
    connector.style.left = "0";
    connector.style.width = "100%";
    connector.style.height = "100%";
    document.body.appendChild(connector);
    return connector;
};
exports.defaultUrl = "https://my.herewallet.app/connector/index.html";
class WidgetStrategy {
    constructor(options = { widget: exports.defaultUrl, lazy: false }) {
        this.options = {
            lazy: typeof options === "object" ? options.lazy || false : false,
            widget: typeof options === "string" ? options : options.widget || exports.defaultUrl,
        };
        if (!this.options.lazy) {
            this.initIframe();
        }
    }
    initIframe() {
        if (WidgetStrategy.connector == null) {
            WidgetStrategy.connector = createIframe(this.options.widget);
            WidgetStrategy.connector.addEventListener("load", () => {
                WidgetStrategy.isLoaded = true;
            });
        }
        return WidgetStrategy.connector;
    }
    onRequested(id, request, reject) {
        const iframe = this.initIframe();
        iframe.style.display = "block";
        const loadHandler = () => {
            var _a, _b, _c;
            (_a = WidgetStrategy.connector) === null || _a === void 0 ? void 0 : _a.removeEventListener("load", loadHandler);
            (_c = (_b = WidgetStrategy.connector) === null || _b === void 0 ? void 0 : _b.contentWindow) === null || _c === void 0 ? void 0 : _c.postMessage(JSON.stringify({ type: "request", payload: { id, request } }), new URL(this.options.widget).origin);
        };
        if (WidgetStrategy.isLoaded)
            loadHandler();
        else
            iframe.addEventListener("load", loadHandler);
        this.messageHandler = (event) => {
            try {
                if (event.origin !== new URL(this.options.widget).origin)
                    return;
                if (JSON.parse(event.data).type === "reject")
                    reject();
            }
            catch (_a) { }
        };
        window.addEventListener("message", this.messageHandler);
    }
    postMessage(data) {
        var _a;
        const iframe = this.initIframe();
        const args = JSON.stringify(data);
        const origin = new URL(this.options.widget).origin;
        (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(args, origin);
    }
    onApproving() {
        this.postMessage({ type: "approving" });
    }
    onSuccess(request) {
        console.log(request);
        this.postMessage({ type: "result", payload: { request } });
        this.close();
    }
    onFailed(request) {
        this.postMessage({ type: "result", payload: { request } });
        this.close();
    }
    close() {
        if (this.messageHandler) {
            window.removeEventListener("message", this.messageHandler);
            this.messageHandler = undefined;
        }
        if (WidgetStrategy.connector) {
            WidgetStrategy.connector.style.display = "none";
        }
    }
}
exports.WidgetStrategy = WidgetStrategy;
WidgetStrategy.isLoaded = false;
//# sourceMappingURL=WidgetStrategy.js.map